/** デバイスの環境だけで出す、秘密の置換の制約の注記。 */
export function DeviceSecretNotice() {
	return (
		<span
			data-testid="device-secret-notice"
			style={{
				fontSize: "var(--text-caption)",
				lineHeight: "var(--leading-body)",
				color: "var(--fg-2)",
				fontFamily: "var(--font-sans)",
			}}
		>
			デバイスのエージェントでは、本文と WebSocket は対象外で、置き換わるのは URL
			とヘッダーにあるプレースホルダだけです。
		</span>
	);
}
